<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
import VipModernProgressCard from "./vip-modern-progress-card.svelte";
const cards = [
	{
		title: Verbiage.rakeback,
		subtitle: Verbiage.vip_modern_distribution_over_3_days,
		balancePercent: 50
	},
	{
		title: Verbiage.vip_modern_daily_cashback,
		subtitle: Verbiage.vip_modern_distribution_over_3_days,
		balancePercent: 30
	},
	{
		title: Verbiage.vip_modern_weekly_cashback,
		subtitle: Verbiage.vip_modern_distribution_over_7_days,
		balancePercent: 30
	},
	{
		title: Verbiage.vip_modern_monthly_cashback,
		subtitle: Verbiage.vip_modern_distribution_over_30_days,
		balancePercent: 30
	}
];
const levelUp = {
	title: Verbiage.vip_modern_level_up_reward,
	subtitle: Verbiage.vip_modern_paid_instantly,
	balancePercent: 100
};
</script>

<section class="vip-rewards-distribution">
	<VipModernEyebrow text={$t(Verbiage.vip_modern_your_rewards)} />

	<Text
		type="title"
		titleSize="h4"
		titleWeight="bold"
		textColor="white"
		textAlign={$isMobile ? 'start' : 'center'}
		className="vip-rewards-distribution-title"
	>
		{$t(Verbiage.vip_modern_rewards_distribution_title)}
	</Text>

	<div class="vip-rewards-distribution-grid">
		{#each cards as card (card.title)}
			<VipModernProgressCard
				title={$t(card.title)}
				subtitle={$t(card.subtitle)}
				balancePercent={card.balancePercent}
			/>
		{/each}

		<VipModernProgressCard
			title={$t(levelUp.title)}
			subtitle={$t(levelUp.subtitle)}
			balancePercent={levelUp.balancePercent}
			customClass="vip-rewards-distribution-full"
		/>
	</div>
</section>

<style>
	.vip-rewards-distribution {

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: flex-start;

		gap: 1.25rem;

		text-align: left
}

	:global(.vip-rewards-distribution-title) {

		font-size: 32px !important
}

	.vip-rewards-distribution-grid {

		margin-top: 1.5rem;

		display: grid;

		width: 100%;

		grid-template-columns: repeat(1, minmax(0, 1fr));

		gap: 1rem
}

	:global(.vip-rewards-distribution-full) {

		width: 100%
}

	@media (min-width: 640px) {
		.vip-rewards-distribution-grid {

				grid-template-columns: repeat(2, minmax(0, 1fr))
		}

		:global(.vip-rewards-distribution-full) {

				grid-column: 1 / -1
		}
	}

	@media (min-width: 1024px) {
		.vip-rewards-distribution {

				align-items: center;

				text-align: center
		}

		:global(.vip-rewards-distribution-title) {

				font-size: 38px !important
		}
	}
</style>
